import axios from 'axios'
import { notificationError } from '../../utils/notification'

const ldap = axios.create({
  baseURL: `${process.env.VUE_APP_API_LDAP}`,
  headers: {
    "Cache-Control": "no-store",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT,DELETE",
    "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
  }
})

ldap.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    error.response?.data 
      ? [400,410].includes(error.response.status) 
        ? ""
        : notificationError('Erro!', `${error.response.data.msg} Status: ${error.response.status}`) 
      : notificationError('Erro!', `Falha na comunicação com o AD.      Status: ${error.message}`)
    throw new Error(error.response.data.error || error.message || false)
  }
)


export { ldap }